import React from 'react';
import { Box, Heading, Text, UnorderedList, ListItem, Link } from '@chakra-ui/react';

export const BlackPowderSilhouette = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        <strong>Contact:</strong> Mike Rix (<Link href="mailto:rmrix@hotmail.com" color="blue.500">rmrix@hotmail.com</Link>)
      </Text>

      <Text mb={4} color="black">
        Any single shot black powder rifle is usually acceptable if it is of a US Caliber that was available prior to the year 1900. Examples are 45-90, 45-70, 40-50, 40-70, etc. Usual single shot rifles are Remington Rolling Block or Hepburn, Winchester, Sharps, Stevens, etc, and they must have an exposed hammer. Iron peep sights are usually used for these events. A few competitors use period scopes, which are telescopic sights that are of a year 1900 vintage or earlier. If there are at least three scope shooters, they will be allowed to compete in their own class separate from the iron sight shooters. This class will have it's own payout.
      </Text>

      <Text mb={4} color="black">
        Shooting competition customarily is a 40 shot for record course of fire which consists of 10 shots at each target at the following ranges:
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem>Metal silhouettes of Chickens at 200 meters (218 yards)</ListItem>
        <ListItem>Metal silhouettes of Pigs at 300 meters (328 yards)</ListItem>
        <ListItem>Metal silhouettes of Turkeys at 385 meters (421 yards)</ListItem>
        <ListItem>Metal silhouettes of Rams at 500 meters (546 yards)</ListItem>
        <ListItem>Chicken targets are shot off hand (standing) only. The remaining targets are shot from either sitting or prone position with the use of cross sticks.</ListItem>
      </UnorderedList>

      <Text mb={4} color="black">
        Beginning relay starts with a 7 minute time limit in which you shoot 5 record targets. Within that time, swingers of the particular animal are available at each range. The competitor can use these swingers as sight in only. Once he or she call for record, they cannot go back to a swinger. The animals must be shot in order. The next relay is 5 minute time limit for the remainder 5 record targets but no swinger shots are allowed.
      </Text>

      <Text mb={4} color="black">
        Payout is determined by the number of shooters in each class. These monthly matches are approved by the National Rifle Association.
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><strong>When:</strong> The First Saturday of the month.</ListItem>
        <ListItem><strong>Alternate Day:</strong> The Second Saturday of the month.</ListItem>
        <ListItem><strong>Time:</strong> Practice 7:30 AM; Matches 9:00 AM.</ListItem>
        <ListItem><strong>Fees:</strong> GGC members: $12.00; non-members: $16.00, women and juniors $8.00.</ListItem>
      </UnorderedList>

      <Text mb={4} color="black">
        All visitors to Golden Gun Club must sign the Visitor Waiver. You only have to sign the waiver once a year, and it will be kept on file at the clubhouse. Sign the Visitor Waiver Online.
      </Text>

      <Text mb={4} color="black">
        Check the Monthly Calendar or call the Range Information Line 303-512-9742 for the schedule of monthly matches.
      </Text>
    </Box>
  );
};